import {Condition} from 'ConditionsFeature';
import {createAction} from 'typesafe-actions';

export const setConditions = createAction(
  'SET_CONDITIONS',
  (conditions: Condition[]) => conditions,
)();
